import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance90 = () => {
  let winners = ["415"];
  return <IndividualTable matchType={"3"} gender="F" event="90" subTitle="TarscaShild" data={sampleData2} topRankCount="1" winners={winners} />;
};
export default Distance90;
